import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid, GridRow, GridColumn, Checkbox } from 'semantic-ui-react';
import { debounce, isNil } from 'lodash';

import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { getId } from 'Common/Security/state/selectors.js';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { ReactTableWrapper } from 'Common/Components/ReactTableWrapper/ReactTableWrapper';
import {
  convertGridSortToSortColumn,
  convertGridFilterToFilter,
} from 'State/paging/helpers';

import {
  getActiveApplication,
  saveFilters,
} from '../../state/manageapplication/actions';

class ApplicationGridForm extends Component {
  reactTableRef = React.createRef();

  state = {
    filtered: [],
    sorted: [
      {
        id: 'StudentLastName',
        desc: false,
      },
      {
        id: 'StudentFirstName',
        desc: false,
      },
    ],
    showIncompleteStatus: false,
    onlyShowApplicationsNotSubByUser: false,
  };

  componentDidMount() {
    this.props.onRef(this);
    if (this.reactTableRef) {
      this.reactTableRef.tableStateChanged();
    }
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { applicationType } = this.props;

    if (prevProps.applicationType !== applicationType && this.reactTableRef) {
      this.reactTableRef.tableStateChanged();
    }

    let sorted =
      applicationType === 'Active' || applicationType === 'SecondReview'
        ? [
            {
              id: 'StudentLastName',
              desc: false,
            },
            {
              id: 'StudentFirstName',
              desc: false,
            },
          ]
        : [
            {
              id: 'HouseholdLastName',
              desc: false,
            },
            {
              id: 'HouseholdFirstName',
              desc: false,
            },
          ];

    if (
      (applicationType === 'Active' &&
        applicationType !== prevProps.applicationType) ||
      (applicationType === 'Deleted' &&
        applicationType !== prevProps.applicationType) ||
      (applicationType === 'Archived' &&
        applicationType !== prevProps.applicationType) ||
      (applicationType === 'Verification' &&
        applicationType !== prevProps.applicationType) ||
      (applicationType === 'SecondReview' &&
        applicationType !== prevProps.applicationType)
    ) {
      this.setState({ sorted });
    }
  };

  fetchData = (state, instance) => {
    const { applicationType, saveFilters, getActiveApplication } = this.props;
    let filters = convertGridFilterToFilter(state.filtered);
    let sorts = convertGridSortToSortColumn(state.sorted);

    let pageOptions = {
      ...this.props.applicationFilters.PagingDetails,
      PageNumber: state.page + 1,
      PageSize: state.pageSize,
      Filter: filters,
      SortColumn: sorts,
    };

    let page = {
      ...this.props.applicationFilters,
      PagingDetails: pageOptions,
      ApplicationType: applicationType,
      ShowIncomplete: this.state.showIncompleteStatus,
      onlyShowApplicationsNotSubByUser: this.state
        .onlyShowApplicationsNotSubByUser,
    };

    saveFilters(page);
    getActiveApplication(page);
  };

  clearFilters = (isTabChange = false) => {
    this.setState({
      filtered: [],
      sorted: [],
    });
    if (isTabChange) {
      this.setState({
        showIncompleteStatus: false,
        onlyShowApplicationsNotSubByUser: false,
      });
    }
    if (!isTabChange) {
      const { applicationFilters, applicationType, saveFilters } = this.props;
      let clearPageOptions = {
        ...applicationFilters.PagingDetails,
        Filter: [],
        SortColumn: [],
      };

      let clearPage = {
        ...applicationFilters,
        PagingDetails: clearPageOptions,
        ApplicationType: applicationType,
      };
      saveFilters(clearPage);
      // getActiveApplication(clearPage);
    }
  };

  showIncompleteChange = (e, data) => {
    this.setState({ showIncompleteStatus: data.checked });
    this.props.getActiveApplication({
      ShowIncomplete: data.checked,
    });
  };

  onlyShowApplicationsNotSubByUserChange = (e, data) => {
    this.setState({ onlyShowApplicationsNotSubByUser: data.checked });
    this.props.getActiveApplication({
      ShowIncomplete: this.state.showIncompleteStatus,
      onlyShowApplicationsNotSubmitted: data.checked,
      userId: this.props.userId,
    });
  };

  updateData = () => {
    this.setState({ filtered: [] });
  };

  fetchDataDebounced = debounce(this.fetchData, 250);

  render() {
    const {
      loading,
      activeApplication,
      columns,
      userId,
      menuOptions,
      availableToDecline,
      applicationType,
      verificationComplete,
    } = this.props;
    const applicationData = (activeApplication && activeApplication.Data) || [];
    const data = applicationData.Result || [];
    const TotalPages = applicationData.TotalPages;
    const tableName = `${TableNamesEnum.MANAGE_APPLICATION_TABLE}_${applicationType}`;

    return (
      <Fragment>
        <Grid>
          <GridRow>
            <GridColumn width="1" />
            <GridColumn width="7" floated="left" textAlign="left">
              <Checkbox
                label="Show Incomplete Only"
                toggle
                onChange={this.showIncompleteChange}
                disabled={loading}
                checked={this.state.showIncompleteStatus}
              />
            </GridColumn>
            {applicationType === 'SecondReview' && (
              <Checkbox
                label="Exclude Applications That I Entered"
                toggle
                onChange={this.onlyShowApplicationsNotSubByUserChange}
                disabled={loading}
                checked={this.state.onlyShowApplicationsNotSubByUser}
              />
            )}
            {applicationType === 'Verification' && (
              <GridColumn width="3" floated="right">
                <label>
                  Available for Decline:{' '}
                  {isNil(availableToDecline) ? 0 : availableToDecline}
                </label>
              </GridColumn>
            )}
            <GridColumn width="1" />
          </GridRow>
        </Grid>

        <ReactTableWrapper
          key={tableName}
          onRef={ref => {
            this.reactTableRef = ref;
          }}
          manual
          data={data}
          saveState={{ tableName }}
          loading={loading}
          onFetchData={this.fetchDataDebounced}
          multiSort={false}
          minRows={data.length === 0 ? 20 : data.length}
          resetPageOnDataChange={false}
          menu="hasCogs"
          pages={TotalPages}
          getTrProps={(state, rowInfo, column) => {
            return {
              style: {
                color:
                  rowInfo &&
                  rowInfo.original &&
                  rowInfo.original.StatusCurrent === '5'
                    ? 'red'
                    : '',
              },
            };
          }}
          columns={[
            ...columns,
            ...[
              {
                width: 50,
                Cell: gridProps => {
                  if (applicationType === 'SecondReview') {
                    return GridContextMenu({
                      gridProps,
                      options: menuOptions(
                        userId === gridProps.original.UserId
                      ),
                    });
                  } else if (applicationType === 'Active') {
                    return GridContextMenu({
                      gridProps,
                      options: menuOptions(
                        gridProps.original,
                        verificationComplete
                      ),
                    });
                  } else {
                    return GridContextMenu({
                      gridProps,
                      options: menuOptions(
                        gridProps.original,
                        availableToDecline,
                        verificationComplete
                      ),
                    });
                  }
                },
              },
            ],
          ]}
        />
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  const {
    ManageApplicationState: { manageApplication },
    CommonState: { controlInfo },
  } = state;
  return {
    userId: getId(state),
    activeApplication: manageApplication.activeApplication,
    applicationFilters: manageApplication.applicationFilters,
    loading: manageApplication.loadingActiveApplications,
    verificationComplete: controlInfo.data.VerificationComplete,
  };
};

const mapDispatchToProps = {
  getActiveApplication,
  saveFilters,
};

export const ApplicationGrid = connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationGridForm);



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/manageapplication/ApplicationGrid.js